import React from "react";
import { Dialog } from "@mui/material";
import {
  ButtonPrimary,
  ButtonCancelSecondary,
  VStack,
  HStack,
  ButtonPrimary1,
} from "../../../../components/utils";
import { Label } from "../../../../components/shared/InputField";
import AlertDialog from "../../../../components/shared/AlertDialog";

type ReminderDialogProps = {
  open: boolean;
  employees?: any[];
  onClose: () => void;
  onSubmit: () => void;
  loading?: boolean;
  notesElement?: React.ReactElement | null;
};

const ReminderEmailDialog = ({
  open,
  employees = [],
  onClose,
  onSubmit,
  loading,
  notesElement,
}: ReminderDialogProps) => (
  <AlertDialog
    message={`Are you sure you want to send reminderEmails for ${
      employees.length
    } employee${employees.length === 1 ? "" : "s"}?`}
    primaryActionText="Send"
    onClose={onClose}
    secondaryActionText="Cancel"
    onPrimaryAction={onSubmit}
    onSecondaryAction={onClose}
    open={open}
    notesElement={notesElement}
  />
);

export default ReminderEmailDialog;
